'use strict';

var jsxRuntime = require('react/jsx-runtime');

var e=jsxRuntime.jsxs("g",{viewBox:"0 0 18 18",fill:"none",children:[jsxRuntime.jsx("path",{d:"M4.11102 1L1 3.66666L4.11102 6.77777",stroke:"currentColor",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}),jsxRuntime.jsx("path",{d:"M1 3.66663H11.2195C14.2786 3.66663 16.8765 6.16458 16.9957 9.22218C17.1217 12.4531 14.452 15.2222 11.2195 15.2222H3.66595",stroke:"currentColor",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"})]});

exports.ReturnIcon = e;
